import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_CUSTOMERS,
    ADD_NEW_CUSTOMER,
    UPDATE_CUSTOMER,
    DELETE_CUSTOMER,
    GET_CUSTOMER_DETAIL,
    EXPORT_CUSTOMERS,
    GET_CUSTOMER_CATEGORIES,
} from "./actionTypes"

import {
    getCustomersSuccess,
    getCustomersFail,
    addNewCustomerSuccess,
    addNewCustomerFail,
    updateCustomerSuccess,
    updateCustomerFail,
    deleteCustomerSuccess,
    deleteCustomerFail,
    getCustomerDetailSuccess,
    getCustomerDetailFail,
    getCustomerCategoriesSuccess,
    getCustomerCategoriesFail,
} from "./actions"

import {
    getCustomers,
    addNewCustomer,
    updateCustomer,
    deleteCustomer,
    getCustomerDetail,
    exportCustomers,
    getCustomerCategories,
} from "../../helpers/fakebackend_helper"

function* fetchCustomerCategories() {
    try {
        const response = yield call(getCustomerCategories)
        yield put(getCustomerCategoriesSuccess(response))
    } catch (error) {
        yield put(getCustomerCategoriesFail(error))
    }
}

function* onGetCustomerDetail({ payload: id }) {
    try {
        const response = yield call(getCustomerDetail, id)
        yield put(getCustomerDetailSuccess(response))
    } catch (error) {
        yield put(getCustomerDetailFail(error))
    }
}

function* onExportCustomers() {
    try {
        const response = yield call(exportCustomers)
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `clients_${new Date().toISOString().split('T')[0]}.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()
    } catch (error) {
        console.log(error)
    }
}

function* fetchCustomers({ payload: params }) {
    try {
        const response = yield call(getCustomers, params)
        yield put(getCustomersSuccess(response))
    } catch (error) {
        yield put(getCustomersFail(error))
    }
}

function* onAddNewCustomer({ payload: customer }) {
    try {
        const response = yield call(addNewCustomer, customer)
        yield put(addNewCustomerSuccess(response.customer))
    } catch (error) {
        yield put(addNewCustomerFail(error))
    }
}

function* onUpdateCustomer({ payload: customer }) {
    try {
        const response = yield call(updateCustomer, customer)
        yield put(updateCustomerSuccess(response.customer))
    } catch (error) {
        yield put(updateCustomerFail(error))
    }
}

function* onDeleteCustomer({ payload: id }) {
    try {
        yield call(deleteCustomer, id)
        yield put(deleteCustomerSuccess(id))
    } catch (error) {
        yield put(deleteCustomerFail(error))
    }
}

function* customersSaga() {
    yield takeEvery(GET_CUSTOMERS, fetchCustomers)
    yield takeEvery(ADD_NEW_CUSTOMER, onAddNewCustomer)
    yield takeEvery(UPDATE_CUSTOMER, onUpdateCustomer)
    yield takeEvery(DELETE_CUSTOMER, onDeleteCustomer)
    yield takeEvery(GET_CUSTOMER_DETAIL, onGetCustomerDetail)
    yield takeEvery(EXPORT_CUSTOMERS, onExportCustomers)
    yield takeEvery(GET_CUSTOMER_CATEGORIES, fetchCustomerCategories)
}

export default customersSaga
